
import Vue from 'vue';

// Services
import MessageService from '~/services/MessageService';

// Assets
import AonSvg from '~/assets/img/aon.svg';
import AonContext, { AonContextData } from '~/services/AonContext';

export default Vue.extend({
    name: 'AssessmentConsentDialog',
    props: {
        context: {
            type: Object as () => AonContext,
            required: true,
        },
    },
    data: () => ({
        aonLogo: AonSvg,
        consented: false,
        isLoading: false,
    }),
    methods: {
        onConsent() {
            this.isLoading = true;
            this.context
                .giveAonConsent({
                    include_instruments: true,
                })
                .then((contextData: AonContextData) => {
                    this.$emit('consented', contextData);
                    this.onClose();
                })
                .catch(() => {
                    MessageService.error(
                        this.$t('assessments.dialog.consentErrorTitle'),
                        this.$t('assessments.dialog.consentErrorMessage')
                    );
                })
                .finally(() => (this.isLoading = false));

            return;
        },
        onClose() {
            this.$emit('close');
        },
    },
});
